import appStore from 'store';
import api from './api';
import hedgeApi from "./hedgeApi";

const store = {

    namespaced: true,

    state: {
        /**净买入量数据list*/
        netPurchases: [],
        totalPurchases: 0,
        /**交易量*/
        tradeVolume: [],
        totalVolume: 0,
        /**净充值量*/
        netDeposit: [],
        totalDeposit: 0,
        /**活动配置信息*/
        configInfo: {},
        /**买入平均成本*/
        avgCostList: [],
        totalAvgCost: 0,
        /**持仓数据统计*/
        coinAccountList: [],
        coinAccountTotal: 0,
        /**交易对下单人数*/
        pairPersonList:[],
        /**用户持仓数据*/
        positionTotal: 0,
        positionList: [],
        snapPosition:[],

        plateListArr:[],

        /** 对冲策略数据,由于后端没有总条数故默认设置300*/
        hedgeStrategy:[],
        strategyTotal:0,
    },

    mutations: {
        setNetPurchases(state, payload) {
            state.netPurchases = payload;
        },
        setTotalPurchases(state, payload) {
            state.totalPurchases = payload;
        },
        setNetDeposit(state, payload) {
            state.netDeposit = payload;
        },
        setTotalDeposit(state, payload) {
            state.totalDeposit = payload;
        },
        setTradeVolume(state, payload) {
            state.tradeVolume = payload;
        },
        setTotalVolume(state, payload) {
            state.totalVolume = payload;
        },
        setConfigInfo(state, payload) {
            state.configInfo = payload;
        },
        setAvgCostList(state, payload) {
            state.avgCostList = payload;
        },
        setTotalAvgCost(state, payload) {
            state.totalAvgCost = payload;
        },
        setCoinAccountList(state,payload) {
            state.coinAccountList = payload;
        },
        setCoinAccountTotal(state,payload) {
            state.coinAccountTotal = payload;
        },
        setPairPersonList(state,payload){
            state.pairPersonList = payload;
        },
        setPositionTotal(state,payload){
            state.positionTotal = payload;
        },
        setPositionList(state,payload) {
            state.positionList = payload;
        },
        setSnapPosition(state,payload) {
            state.snapPosition = payload;
        },
        setPlateList(state,payload) {
            payload.map(function(item,index,arr){
                item.pairsJsonArr=JSON.parse(item.pairsJson);
                item.name=JSON.parse(item.name);
            });
            state.plateListArr = payload;
        },
        setHedgeStrategy(state,payload) {
            state.hedgeStrategy = payload.list;
            state.strategyTotal = payload.totalCount;
        }
    },

    actions: {
        getNetDeposit({commit}, page) {
            api.getNetDepositStatisticInfo({page: page, size: 25}).then(response => {
                commit('setNetDeposit', response.data.list);
                commit('setTotalDeposit', response.data.totalCount);
            })
        },

        getNetPurchases({commit}, page) {
            api.getNetPurchasesStatisticInfo({page: page, size: 25}).then(response => {
                commit('setNetPurchases', response.data.list);
                commit('setTotalPurchases', response.data.totalCount);
            })
        },

        getTradeVolume({commit}, page) {
            api.getTradeVolumeStatisticInfo({page: page, size: 25}).then(response => {
                commit('setTradeVolume', response.data.list);
                commit('setTotalVolume', response.data.totalCount);
            })
        },

        getConfigInfo({commit}) {
            return new Promise((resolve) => {
                api.getTradeActivityConfig().then(response => {
                    commit('setConfigInfo', response.data);
                    resolve(response.data);
                })
            })
        },

        findConfig({commit}) {
            api.getTradeAConfig().then(response => {
                commit('setConfigInfo', response.data);
            })
        },

        buildConfig({commit},data) {
            return api.buildTradeActivityConfig(data);
        },

        clearStatistic() {
            return api.clearTradeStatistic();
        },

        getTradeAvgCostInfo({commit},data) {
            api.getAvgCost(data).then(response => {
                commit('setAvgCostList',response.data.list);
                commit('setTotalAvgCost',response.data.totalCount)
            })
        },

        exportTradeAvgCost({commit},data){
            return api.exportAvgCost(data);
        },

        getCoinAccountList({commit},data){
            api.getCoinAccount(data).then(response => {
                commit('setCoinAccountList',response.data.list);
                commit('setCoinAccountTotal',response.data.totalCount);
            })
        },

        exportCoinAccountData({commit},data){
            return api.exportCoinAccount(data);
        },

        getPairPerson({commit},data) {
            api.selectPairPerson(data).then(response => {
                commit('setPairPersonList',response.data);
            })
        },

        getUserPosition({commit},data){
            api.selectPosition(data).then(response => {
                commit('setPositionTotal',response.data.totalCount);
                commit('setPositionList',response.data.list);
            })
        },

        buildSnapPosition({commit},data) {
            api.getSnapPosition(data).then(response => {
                commit('setSnapPosition',response.data);
            })
        },


        //板块
        getPlateList({commit},data) {
            api.getPlateList(data).then(response => {
                commit('setPlateList', response.data);
            })
        },

        //对冲策略
        getStrategyList({commit},data){
            hedgeApi.findRiskHedgeStrategies(data).then(response =>{
                commit('setHedgeStrategy',response.data);
            })
        }
    }

}

appStore.registerModule('tradeStatistic', store);
